var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1170",
    width: 256,
    height: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1171"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1172"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 25 24",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M6 1.75a.75.75 0 0 0 0 1.5h1.25v1.826A8.328 8.328 0 0 0 10.951 12a8.328 8.328 0 0 0-3.701 6.924v1.826H6a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5h-1.25v-1.826A8.328 8.328 0 0 0 14.049 12a8.328 8.328 0 0 0 3.701-6.924V3.25H19a.75.75 0 0 0 0-1.5H6Zm2.783 16.5H16a.75.75 0 0 1 .22.033 6.828 6.828 0 0 0-3.72-5.453 6.828 6.828 0 0 0-3.717 5.42Zm7.467 1.457a.747.747 0 0 1-.25.043H8.75v1h7.5v-1.043ZM12.5 11.17a6.828 6.828 0 0 0 3.205-3.42h-6.41a6.827 6.827 0 0 0 3.205 3.42Zm3.75-6.094c0 .403-.035.8-.104 1.188A.754.754 0 0 0 16 6.25H8.852a6.832 6.832 0 0 1-.102-1.174V3.25h7.5v1.826Z",
    clipRule: "evenodd",
    className: "color292D32 svgShape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.4d5082af5454f50f1210cb07d615b74e.svg";
export { ForwardRef as ReactComponent };